import { create } from "zustand";

import UserApiCaller from "../config/api/userapicaller";
import { readCache, readMapCache, writeCache, writeMapCache } from "./cache";

const COUNTRY_TTL = 24 * 60 * 60 * 1000;

const cacheStore = {
  countries: { data: null, expiresAt: 0 },
  states: new Map(),
};

const initialState = {
  countries: [],
  states: [],
  isCountriesLoading: false,
  isStatesLoading: false,
  error: null,
};

export const useCountryStore = create((set) => {
  const setCountries = (partial) => set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    getCountries: async (cb) => {
      try {
        setCountries({ isCountriesLoading: true, error: null });
        const cached = readCache(cacheStore.countries);
        if (cached) {
          setCountries({ countries: cached, isCountriesLoading: false });
          if (cb) cb(cached);
          return;
        }
        const res = await UserApiCaller.Get("/user/country", {}, {
          cache: true,
          ttlMs: COUNTRY_TTL,
        });
        if (res?.status === 200) {
          setCountries({
            countries: res?.data?.data,
            isCountriesLoading: false,
          });
          writeCache(cacheStore.countries, res?.data?.data, COUNTRY_TTL);
        } else {
          setCountries({ isCountriesLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setCountries({ isCountriesLoading: false, error: err });
      }
    },
    getStates: async (payload, cb) => {
      try {
        setCountries({ isStatesLoading: true, error: null });
        const cacheKey = JSON.stringify(payload ?? {});
        const cached = readMapCache(cacheStore.states, cacheKey);
        if (cached) {
          setCountries({ states: cached, isStatesLoading: false });
          if (cb) cb({ data: cached });
          return;
        }
        const res = await UserApiCaller.Post("/user/state", payload);
        if (res?.status === 200) {
          setCountries({ states: res?.data?.data, isStatesLoading: false });
          writeMapCache(cacheStore.states, cacheKey, res?.data?.data, COUNTRY_TTL);
        } else {
          setCountries({ isStatesLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setCountries({ isStatesLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
